import { render, staticRenderFns } from "./CkButton.vue?vue&type=template&id=581049be&scoped=true&"
import script from "./CkButton.vue?vue&type=script&lang=js&"
export * from "./CkButton.vue?vue&type=script&lang=js&"
import style0 from "./CkButton.vue?vue&type=style&index=0&id=581049be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581049be",
  null
  
)

export default component.exports